var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$root.keyApplication,staticClass:"d-flex flex-column h-100",attrs:{"id":"app"}},[(_vm.ready)?[_c('transition',{attrs:{"name":"website-fade","mode":"out-in"}},[(!_vm.introduction)?_c('introduction',{attrs:{"phrases":_vm.phrases},on:{"introductionComplete":function($event){return _vm.introductionComplete()}}}):_c('website')],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02f53c32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 